import { AppButton, AppTextField } from 'components';
import { Link } from 'react-router-dom';
import { Fragment, useEffect, useState } from 'react';
import StatusDropDown from 'components/molecules/StatusDropDown';
import Joi from 'joi';
import { checkForErrors } from 'utilities/fns';
import useStatus from 'hooks/useStatus';

function ESTHandleSection({ handleClass, preloadedData = {}, editMode }) {
  const [status, handleStatus] = useStatus();
  const [className, handleClassName] = useState('');
  const [classKey, handleClassKey] = useState('');
  const [formErrors, setFormErrors] = useState([]);

  useEffect(() => {
    if (preloadedData?._id) {
      handleClassName(preloadedData?.name ?? '');
      handleClassKey(preloadedData?.key ?? '');
      if (preloadedData?.status) handleStatus(preloadedData?.status);
    }
  }, [handleStatus, preloadedData]);

  function handleFormSubmission() {
    setFormErrors([]);

    const data = {
      name: className,
      key: classKey,
      status,
    };

    const validation = manageClassSchema.validate(data, { abortEarly: false, allowUnknown: true });

    if (validation?.error) {
      setFormErrors(validation.error?.details ?? []);
      return;
    }

    handleClass(data);
  }

  const errors = checkForErrors(formErrors);

  return (
    <Fragment>
      <div className="row">
        <div className="col-12">
          <h2 className="prime-head p-0 boldtitle">{editMode ? 'Update Region' : 'Add Region'}</h2>
        </div>
      </div>

      <div className="row mt-4">
        <div className="col-lg-4 col-md-6 col-sm-12">
          <AppTextField
            inputProps={{
              value: className,
              onChange: (event) => handleClassName(event.target.value),
              placeholder: 'Curriculum name *',
            }}
            labelProps={{ label: 'Name' }}
            fieldErrors={errors['name']}
          />
        </div>
        <div className="col-lg-4 col-md-6 col-sm-12">
          <AppTextField
            inputProps={{
              value: classKey,
              onChange: (event) => handleClassKey(event.target.value),
              placeholder: 'Curriculum key (leave blank for auto-generation)',
            }}
            labelProps={{ label: 'Key' }}
            fieldErrors={errors['key']}
          />
        </div>
        <div className="col-lg-4 col-md-6 col-sm-12">
          <StatusDropDown
            value={status}
            handleChange={(event) => handleStatus(event.target.value)}
            fieldErrors={errors['status']}
          />
        </div>
      </div>

      <div className="row mt-5">
        <div className="col-12 btnTab-foot d-flex justify-content-end">
          <AppButton variantClass="btn-primary mx-3" onClick={handleFormSubmission}>
            Save Changes
          </AppButton>
        </div>
      </div>
    </Fragment>
  );
}

ESTHandleSection.defaultProps = {
  handleClass: () => {},
};

const manageClassSchema = Joi.object({
  name: Joi.string().required().min(2),
  status: Joi.string().required(),
});

export default ESTHandleSection;
